// Credit Readiness lib — types + API helpers
import { api } from "./api";

export const FICO_BANDS = [
  "<580", "580-619", "620-659", "660-699", "700-739", "740-779", "780+",
];

export const ENTITY_TYPES = ["LLC", "S-Corp", "C-Corp", "Sole-Prop", "Partnership", "Trust", "Other"];

export const ADDRESS_TYPES = [
  { id: "commercial", label: "Commercial address" },
  { id: "residential", label: "Residential" },
  { id: "virtual", label: "Virtual office" },
  { id: "mailbox", label: "PO box / mailbox service" },
  { id: "none", label: "No registered address" },
];

export const PREFERRED_CHANNELS = [
  { id: "UHNW", label: "UHNW Family Office" },
  { id: "HNW", label: "HNW Family Office" },
  { id: "Family-Office", label: "Family Trust Office" },
  { id: "VC", label: "Venture Capital" },
  { id: "Angel", label: "Angel Investment" },
  { id: "CDFI", label: "CDFI" },
  { id: "SBFE", label: "SBFE Reporting" },
  { id: "SBA", label: "SBA Loans" },
  { id: "CBD-Grants", label: "CBD / Grants" },
  { id: "Private-Equity", label: "Private Equity Accreditation" },
  { id: "Commercial-Bank", label: "Commercial Bank LOC" },
  { id: "Letters-of-Credit", label: "Letters of Credit" },
  { id: "Guarantors", label: "Guarantors / Grantors" },
  { id: "Tradelines", label: "Net-30 Tradelines" },
];

export async function submitCreditReadiness(payload) {
  const { data } = await api.post("/credit-readiness/apply", payload);
  return data;
}

export async function getCreditReadiness(id) {
  const { data } = await api.get(`/credit-readiness/${id}`);
  return data;
}

export async function listLenders() {
  const { data } = await api.get("/credit-readiness/lenders");
  return data;
}
